var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"terms-page"},[_c('div',{staticClass:"container"},[(_vm.$store.state.campaign)?[_c('div',{staticClass:"terms",domProps:{"innerHTML":_vm._s(_vm.$store.state.campaign.terms)}})]:_vm._e()],2)])}
var staticRenderFns = []

export { render, staticRenderFns }